import { useState, useEffect, useRef } from "react"
import { caseService } from '../../../services/caseService';
import { notify } from '../../../assets/helpers/toast';
import { useParams } from "react-router-dom";
import { useJsApiLoader } from '@react-google-maps/api';
import { FollowingMap } from "./FollowingMap"
import logo from '../../../images/logoFollowing.svg';
import phoneFollowing from '../../../images/phoneFollowing.svg';
import whatsappFollowing from '../../../images/whatsappFollowing.svg';
import persona from "../../../images/persona.svg"
import casa from "../../../images/casa.svg"
import towFollowing from '../../../images/towFollowing.svg';
import bikeFollowing from '../../../images/bikeFollowing.svg';
import { capitalize, calculateMiddlePoint } from "../../../assets/helpers/funciones";
import { enumStatus, OPERATIONS_PHONE } from "../../../assets/helpers/options.js"
import { useHistory } from "react-router-dom";
import { LoadSpinner } from "../../common/LoadSpinner/LoadSpinner.jsx";
import elipse from '../../../images/elipse.svg';
import facebookWhite from '../../../images/facebookWhite.svg';
import instagramWhite from '../../../images/instagramWhite.svg';
import twitterWhite from '../../../images/twitterWhite.svg';

const { AV_ASSIGNED, AV_ON_ROAD, AV_IN_ORIGIN, CANCELED, TOW_ASSIGNED, TOW_ON_ROAD, TOW_IN_ORIGIN, CUSTOMER_ON_ROAD, FINISHED,
} = enumStatus

const networks = [
    { src: facebookWhite, alt: "facebookWhite", url: "https://www.facebook.com/p/Tu-Gruero-100066840556940/" },
    { src: instagramWhite, alt: "instagramWhite", url: "https://www.instagram.com/tugruero/?hl=en" },
    { src: twitterWhite, alt: "twitterWhite", url: "https://x.com/tugruero" },
]


export const FollowingLink = () => {

    const history = useHistory();

    const intervalRef = useRef(null);
    const [following, setFollowing] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [origin, setOrigin] = useState({});
    const [destiny, setDestiny] = useState({});
    const [finalDestiny, setFinalDestiny] = useState({});
    const [displayMessage, setDisplayMessage] = useState(false);
    const [directionsResponse, setDirectionsResponse] = useState(null);
    const [directionsResponse2, setDirectionsResponse2] = useState(null);
    const [route, setRoute] = useState({
        distance: '',
        time: '',
    });
    const [route2, setRoute2] = useState({
        distance: '',
        time: '',
    });

    const { caseId } = useParams();
    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        libraries: ['places'],
    });

    const getCaseById = () => {
        caseService
            .getTowLocation(caseId)
            .then((response) => {
                if (response.status === 200) {
                    setDisplayMessage(false);
                    setFollowing(response?.data);


                    if ([AV_ASSIGNED, AV_ON_ROAD, AV_IN_ORIGIN,]?.includes(response?.data?.case?.status)) {
                        // Bike
                        let origin = {
                            lat: parseFloat(response?.data?.locationMobile?.lat),
                            lng: parseFloat(response?.data?.locationMobile?.lon),
                            location: capitalize(response?.data?.locationMobile?.location),
                            icon: bikeFollowing
                        }
                        // Client
                        let destiny = {
                            lat: parseFloat(response?.data?.case?.originLatitude),
                            lng: parseFloat(response?.data?.case?.originLongitude),
                            location: capitalize(response?.data?.case?.originAddress),
                            icon: persona
                        }

                        if (!response?.data?.case?.originLatitude) {
                            notify(`originLatitude missing`, 'info');
                        }

                        if (!response?.data?.case?.originLongitude) {
                            notify(`originLongitude missing`, 'info');
                        }

                        setOrigin(origin);
                        setDestiny(destiny);
                        calculateRoute(origin, destiny)
                    }

                    if ([TOW_ASSIGNED, TOW_ON_ROAD, TOW_IN_ORIGIN]?.includes(response?.data?.case?.status)) {
                        // Tow
                        let origin = {
                            lat: parseFloat(response?.data?.locationMobile?.lat),
                            lng: parseFloat(response?.data?.locationMobile?.lon),
                            location: capitalize(response?.data?.locationMobile?.location),
                            icon: towFollowing
                        }
                        // Client
                        let destiny = {
                            lat: parseFloat(response?.data?.case?.originLatitude),
                            lng: parseFloat(response?.data?.case?.originLongitude),
                            location: capitalize(response?.data?.case?.originAddress),
                            icon: persona
                        }

                        let finalDestiny = {
                            lat: parseFloat(response?.data?.case?.destinyLatitude),
                            lng: parseFloat(response?.data?.case?.destinyLongitude),
                            location: capitalize(response?.data?.case?.destinyAddress),
                            icon: casa
                        }


                        setOrigin(origin);
                        setDestiny(destiny);
                        setFinalDestiny(finalDestiny);
                        calculateRoute(origin, destiny)
                        calculateRoute2(destiny, finalDestiny)
                    }

                    if ([CUSTOMER_ON_ROAD]?.includes(response?.data?.case?.status)) {
                        // Tow
                        let origin = {
                            lat: parseFloat(response?.data?.locationMobile?.lat),
                            lng: parseFloat(response?.data?.locationMobile?.lon),
                            location: capitalize(response?.data?.locationMobile?.location),
                            icon: towFollowing
                        }
                        // Client
                        let destiny = {
                            lat: parseFloat(response?.data?.case?.destinyLatitude),
                            lng: parseFloat(response?.data?.case?.destinyLongitude),
                            location: capitalize(response?.data?.case?.destinyAddress),
                            icon: casa
                        }
                        setOrigin(origin);
                        setDestiny(destiny);
                        calculateRoute(origin, destiny)
                    }



                    if ([CANCELED]?.includes(response?.data?.status)) {
                        history.push(`/following-link/${caseId}/canceled`)
                    }

                    if ([FINISHED]?.includes(response?.data?.status)) {
                        history.push(`/following-link/${caseId}/finished`)
                    }


                    if (!response?.data?.locationMobile?.lat || !response?.data?.locationMobile?.lon) {
                        setDisplayMessage(true);
                        console.log(`locationMobile missing`, 'info');
                    }

                    setIsLoading(false);
                    return
                }

                if (response.status === 400) {
                    if (response?.data?.message === 'Provider is external') {
                        history.push(`/following-link/${caseId}/external`)
                    }
                    return
                }

                else {
                    notify(`${response.message}`, 'error');
                }
            })
            .catch(() => { });
    };


    async function calculateRoute(origin, destiny) {
        if (!origin || !destiny) {
            return;
        }
        // eslint-disable-next-line no-undef
        const directionsService = new google.maps.DirectionsService();
        const results = await directionsService.route({
            // eslint-disable-next-line no-undef
            origin: new google.maps.LatLng(origin?.lat, origin?.lng),
            // eslint-disable-next-line no-undef
            destination: new google.maps.LatLng(destiny?.lat, destiny?.lng),
            // eslint-disable-next-line no-undef
            travelMode: google.maps.TravelMode.DRIVING,
        });

        // Colocar una alerta de que no se puede determinar una ruta
        setDirectionsResponse(results);
        setRoute({
            time: (results.routes[0].legs[0].duration.value / 60).toFixed(), //Valor de metros a Km
            distance: (results.routes[0].legs[0].distance.value / 1000).toFixed(2), // Valor de segundos a minutos
        });
    }

    async function calculateRoute2(origin, destiny) {
        if (!origin || !destiny) {
            return;
        }
        // eslint-disable-next-line no-undef
        const directionsService = new google.maps.DirectionsService();
        const results = await directionsService.route({
            // eslint-disable-next-line no-undef
            origin: new google.maps.LatLng(origin?.lat, origin?.lng),
            // eslint-disable-next-line no-undef
            destination: new google.maps.LatLng(destiny?.lat, destiny?.lng),
            // eslint-disable-next-line no-undef
            travelMode: google.maps.TravelMode.DRIVING,
        });

        // Colocar una alerta de que no se puede determinar una ruta
        setDirectionsResponse2(results);
        setRoute2({
            time: (results.routes[0].legs[0].duration.value / 60).toFixed(), //Valor de metros a Km
            distance: (results.routes[0].legs[0].distance.value / 1000).toFixed(2), // Valor de segundos a minutos
        });
    }



    useEffect(() => {
        getCaseById()
    }, []);

    useEffect(() => {


        intervalRef.current = setInterval(getCaseById, 10 * 1000); // 10 seconds in milliseconds
        // Cleanup function to clear the interval when the component unmounts
        return () => clearInterval(intervalRef.current);
    }, []);

    if (!isLoaded) {
        return null;
    }


    return (
        <div style={{ minHeight: "100vh" }} >
            <LoadSpinner show={isLoading} />
            <FollowingLinkHeader />
            {displayMessage ? <MessageFollowing /> :
                <>
                    <FollowingMap data={[origin, destiny, finalDestiny]} middlePoint={calculateMiddlePoint([origin, destiny])} directionsResponse={directionsResponse} directionsResponse2={directionsResponse2} />
                    <FollowingLinkFooter data={following} route={route} />
                </>
            }
        </div>
    )
}

export const FollowingLinkHeader = () => {
    return (
        <div className="following-link-header">
            <img src={logo} alt="" />
        </div>
    )
}

export const FollowingLinkFooter = (props) => {
    const { data, route } = props
    const providePhone = data?.provider?.phone ? data?.provider?.phone.replace(/-/g, '').replace(/^0/, '') : null
    return (
        <div className="following-link-footer">
            <div className="following-link-footer-banner" ><h4>Información del Gruero</h4></div>
            <div className="following-link-footer-provider-info-container" >

                <div className="following-link-footer-provider-info">
                    <div>
                        <h6 style={{ color: "white" }}>
                            {data?.provider?.name}
                        </h6>
                        <p>{data?.provider?.type}</p>
                    </div>
                    <div>
                        <a href={`tel:+58${providePhone}`}>
                            <img src={phoneFollowing} alt="phoneFollowing" />
                        </a>
                        <a href={`whatsapp://send?phone=+58${providePhone}&text=Hola, tengo un servicio activo y tengo la siguiente duda: !`}>
                            <img src={whatsappFollowing} alt="whatsappFollowing" />
                        </a>
                    </div>
                </div>

            </div>
            <div className="following-link-footer-vehicle-info">
                <div>
                    <h6>Placa de la {data?.provider?.type === 'Asistente Vial' ? "Moto" : "Grua"}:</h6>
                    <b>{data?.vehicle?.plate}</b>
                </div>
                <div>

                    {[CUSTOMER_ON_ROAD].includes(data.status) ? <h6>Llegarás a tu destino en</h6> : <h6>Llegando a buscarte en</h6>}

                    <b>{route?.time} Minutos</b>
                </div >
                <p style={{ marginTop: "12px", fontSize: "10px", textAlign: "center" }}>La ruta mostrada es referencial, el conductor podría tomar otra vía más óptima</p>
            </div >
        </div >
    )
}

export const MessageFollowing = () => {
    return (
        <div className="message-following-component">
            <span style={{ marginTop: "46px" }}></span>
            <div style={{ alignItems: "center", justifyContent: "center" }} className="following-message-body">
                <p style={{ textAlign: "center", padding: "0 20px", lineHeight: 1.6 }}>
                    Mapa no disponible
                    <br />
                    ¡Estamos trabajando para ti, disculpa las molestias ocasionadas!
                </p>
            </div>

            <div className="message-following-social-networks">
                <div>
                    {networks.map((n, index) => (
                        <a key={n.alt} href={n.url} target="_blank" >
                            <img src={n.src} alt="facebookWhite" />
                        </a>
                    ))}
                </div>
                <div>Siguenos en nuestras redes</div>
            </div>


            <img className="elipse" src={elipse} alt="elipse" />
        </div>

    )
}